import React from 'react';
import { SFButton, SFIconButton, SFMenu, SFMenuItem } from 'sfui';
import styles from './ProjectCardActions.module.scss';

export interface ProjectCardActionsProps {
  isButtonDisabled: boolean;
  onSeeRecentReports: () => void;
}

export const ProjectCardActions = ({
  isButtonDisabled,
  onSeeRecentReports
}: ProjectCardActionsProps): React.ReactElement<ProjectCardActionsProps> => {
  const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<any>();

  const onClick = (e: any) => {
    if (!isMenuOpen) {
      setAnchorEl(e.currentTarget);
      setIsMenuOpen(true);
    }
  };

  return (
    <div className={styles.projectCardActions}>
      <div className={styles.actionsMenu}>
        <SFIconButton
          className={styles.btnMenu}
          sfIcon="Other"
          sfSize="medium"
          onClick={onClick}
          aria-label="More Options"
        />

        <SFMenu
          open={isMenuOpen}
          anchorEl={anchorEl}
          onClose={() => setIsMenuOpen(false)}
        >
          <SFMenuItem
            disabled={isButtonDisabled}
            onClick={() => {
              onSeeRecentReports();
              setIsMenuOpen(false);
            }}
          >
            See Recent Reports
          </SFMenuItem>
        </SFMenu>
      </div>

      <div className={styles.actionsButtons}>
        <SFButton
          variant="outlined"
          disabled={isButtonDisabled}
          onClick={onSeeRecentReports}
        >
          See Recent Reports
        </SFButton>
      </div>
    </div>
  );
};
